const cartDefaultState = {
  marketplaceInfo: {},
  addedItems: [],
  osName: '',
};

module.exports = cartDefaultState;
